/**
 * Generic Telehealth Integration Service
 *
 * This service provides a simple way to launch telehealth platforms (Zoom, Doxy.me, Teams, etc.)
 * without requiring API integration. Just configure a static/recurring meeting URL.
 *
 * DEMO SETUP:
 * 1. Create a recurring meeting in your telehealth platform (e.g., Zoom)
 * 2. Copy the join URL
 * 3. Update TELEHEALTH_URL below
 * 4. Done!
 */

export interface TelehealthConfig {
  provider: 'Zoom' | 'Doxy.me' | 'Teams' | 'Other';
  meetingUrl: string;
  displayName: string;
}

// TODO: Replace with your actual recurring meeting URL
// To create a recurring Zoom meeting:
// 1. Go to zoom.us → Schedule a Meeting
// 2. Check "Recurring meeting" with "No Fixed Time"
// 3. Save and copy the join URL (e.g., https://zoom.us/j/123456789)
const DEMO_TELEHEALTH_CONFIG: TelehealthConfig = {
  provider: 'Zoom',
  meetingUrl: 'https://medarrive.zoom.us/j/9919019872?pwd=bYMcT0YOUWqeGhcfqUtf2qlyyePjzq.1', // Replace this!
  displayName: 'Virtual Visit Room'
};

/**
 * Get the configured telehealth URL
 */
export function getTelehealthUrl(): string {
  return DEMO_TELEHEALTH_CONFIG.meetingUrl;
}

/**
 * Get the full telehealth configuration
 */
export function getTelehealthConfig(): TelehealthConfig {
  return DEMO_TELEHEALTH_CONFIG;
}

/**
 * Launch the telehealth platform in a new window
 * This is the main function called when "Join Call" is clicked
 */
export function launchTelehealthCall(): void {
  const url = getTelehealthUrl();
  window.open(url, '_blank');
}
